import {CLStore} from 'common/src/redux/store';
import initializeCreativeTemplatesAgents from './initializeCreativeTemplatesAgents';
import initializeCreativeTemplatesUiContexts from './initializeCreativeTemplatesUiContexts';

function initializeCreativeTemplates(store: CLStore) {
  initializeCreativeTemplatesUiContexts(store);
  initializeCreativeTemplatesAgents(store);
}

export default initializeCreativeTemplates;
